module.exports = __webpack_public_path__ + "static/media/inizio.2ebde310.png";